import { QuestStatus } from 'src/enums/quests';
import { TaskSummary } from './task';
import { BeehiveHumanReviewStatus } from './quests';

export interface ClientQuest {
    quest: Quest;
    netTime: number;
    iteration: number;
    progress: number;
    planningStatus?: string;
    planningSessionId?: string;
    beehiveHumanReviewStatus?: BeehiveHumanReviewStatus | null;
}

export const QuestStatusMap: Record<QuestStatus, string> = {
    [QuestStatus.NEW]: 'Pending',
    [QuestStatus.IN_PROCESS]: 'In progress',
    [QuestStatus.IN_REVIEW]: 'In review',
    [QuestStatus.DONE]: 'Solved',
    [QuestStatus.CANCELLED]: 'Cancelled',
    [QuestStatus.ON_HOLD]: 'On hold',
    [QuestStatus.ARCHIVED]: 'Archived',
    [QuestStatus.UNARCHIVED]: 'Unarchived',
    [QuestStatus.PLANNING]: 'Planning',
    [QuestStatus.DRAFT]: 'Draft'
};

export interface Quest {
    id: string;
    status: QuestStatus;
    questType: string;
    title: string;
    description: string;
    created: string;
    projectId: number;
    links: string[];
    priority: number;
    iterations: number;
    tasks?: TaskSummary[];
    isMerged?: boolean;
    beehiveHumanReviewStatus?: BeehiveHumanReviewStatus | null;
}

export interface Project {
    id: string;
    name: string;
}

export interface Repository {
    id: number;
    name: string;
    url: string;
    project: Project;
}
